<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m1kEXG/tc-custom/9780253024633.jpg?1737195673622" alt="This image is the cover for the book Jewish Revolution in Belorussia, The Modern Jewish Experience"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jewish Revolution in Belorussia, The Modern Jewish Experience
      </h1>
      <p class="bookDescription body article font2">
        <b>A Dorothy Rosenberg Prize–winner: "A remarkable social history that investigates the process of Sovietization among Jews in Belorussia” (Jeffrey Veidlinger, author of <i>In the Shadow of the Shtetl</i>).</b><br/><br/> This insightful history demonstrates how Jewish life in Belorussia fundamentally changed when Jews started joining the Bolshevik movement and populating the front lines of the revolutionary struggle. While Andrew Sloin’s story follows the arc of Bolshevik history, it also shows how the broader movement was enacted in factories and workshops, workers’ clubs and union meetings, and on the Jewish streets of White Russia.<br/><br/> In the eyes of the Bolshevik leadership, the project of transforming Jews into integrated Soviet citizens was bound inextricably to labor. The protagonists here are shoemakers, speculators, glassmakers, peddlers, leatherworkers, needleworkers, soldiers, students, and local party operatives who were swept up, willingly or otherwise, under the banner of Marxist socialism. With extensive research and keen insight, Sloin stresses the fundamental relationship between economy and identity formation as party officials grappled with the Jewish Question in the wake of the revolution.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Sloin
      </h2>
      
      <p class="authorDescription body article">Andrew Sloin is Assistant Professor of History at Baruch College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?789f4861